<template>
  <div class="user">
    <!-- Table -->
    <v-card>      
      <v-data-table
        :headers="headers"
        :items="this.$store.state.charge.charges.charges.data"
        :search="search"
        hide-default-footer
        :loading="this.$store.state.charge.charges.isLoading"
        :items-per-page="20"
        loading-text="Cargando... Por favor espere"
        no-data-text="No hay registro"
        no-results-text="Lo sentimos no hay registro para su busqueda, intente con otro"
      >
        <template v-slot:[`item.monthly_salary`]="item">
          {{ item.item.monthly_salary | formatNumber }}
        </template>
        <template v-slot:[`item.total_salary`]="item">
          {{ item.item.total_salary | formatNumber }}
        </template>
        <template v-slot:[`item.status`]="item">
          <v-chip :color="getEmployeeStatuColor(item.item.status)" dark small>
            {{ getEmployeeStatus(item.item.status) }}
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="item">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="show(item.item.id)"
              >
                mdi-eye-outline
              </v-icon>
            </template>
            <span>Ver</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="success"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="edit(item.item.id)"                
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>         
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="red"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="datele(item.item, 'INACTIVE', true)"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-col cols="12" sm="12" md="12">
        <v-pagination
          v-model="pagination.current"
          :length="pagination.total"
          :total-visible="8"
          circle
          @input="nextPage"
        ></v-pagination>
      </v-col>
    </v-card>

    <delete
      :active.sync="activeDelete"
      :id="currentCharge.id"
      :name="currentCharge.name"
    ></delete>

    <!-- Button active dialog / create record-->
    <v-btn
      class="mx-2"
      fab
      dark
      bottom
      absolute
      right
      color="secondary"
      href="/charges/create"
    >
      <v-icon dark> mdi-plus </v-icon>
    </v-btn>
  </div>
</template>

<script>
/* import { SET_ALERT } from "@/store/alert"; */
import { mapGetters } from "vuex";
import { SET_CHARGES } from "@/store/charge/charges";
import Delete from "@/components/charge/Delete";
export default {
  name: "Employees",
  components: {
    Delete,
  },
  filters: {
    formatNumber(value) {      
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
      }).format(value);
    },
  },
  data: () => ({
    search: "",
    headers: [
      {
        text: "Nombre",
        align: "start",
        filterable: false,
        value: "name",
      },          
      { text: "Estado", value: "status", filterable: false },
      { text: "Acciones", value: "actions", filterable: false },
    ],
    pagination: {
      current: 0,
      total: 0,
    },    
    activeDelete: false,    
    currentCharge: {},
  }),
  created() {
    this.$store.dispatch("getCharges");
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === SET_CHARGES) {
        this.pagination.current = state.charge.charges.charges.current_page;
        this.pagination.total = state.charge.charges.charges.last_page;
      }
    });
  },
  computed: {
    ...mapGetters(["getEmployeeStatus", "getEmployeeStatuColor"]),
  },
  methods: {
    show(id) {
      window.open(`/charges/show/${id}`, '_blank').focus();      
    },
    edit(id) {
      window.open(`/charges/edit/${id}`, '_blank').focus();      
    },
    nextPage() {
      this.$store.dispatch("nextPageCharges", this.pagination.current);
    },
    datele(item) {
      this.currentCharge = item;
      this.activeDelete = true;
    },
  },
};
</script>
<style scoped>
.user {
  height: 100%;
}
.v-btn--bottom {
  bottom: 11px !important;
}
</style>
